// Wave 20.47d — brand bar for public drop-link pages.
//
// Mounts at the top of any /shared/*, /dropped/*, /peak/*, or
// /replay/* page. Two goals:
//   1. Every drop-link viewer sees the aero.chat identity.
//   2. Every drop-link viewer has a one-tap path into signup.
// Logo click, "Join aero.chat" click, and the whole bar are all
// linked to /register.

import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Logo from '../Logo';
import { colors } from '../theme';

interface Props {
  /** Optional CTA line — e.g. an expiration countdown that ticks
   *  on the host page. Rendered between the wordmark and the
   *  Join CTA. Keep it short. */
  meta?: React.ReactNode;
}

export default function DropPageBrandBar({ meta }: Props) {
  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 40,
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        px: { xs: 1.5, sm: 2 },
        py: 1,
        backgroundColor: 'rgba(10,14,26,0.92)',
        borderBottom: `1px solid ${colors.border}`,
        backdropFilter: 'blur(10px)',
      }}
    >
      <RouterLink
        to="/register"
        aria-label="Join aero.chat"
        style={{ display: 'inline-flex', alignItems: 'center', textDecoration: 'none' }}
      >
        <Logo width={46} height={26} />
      </RouterLink>
      {meta ? (
        <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0, flex: 1 }}>
          <Box sx={{ width: 1, height: 16, backgroundColor: 'rgba(255,255,255,0.15)' }} />
          <Box sx={{ minWidth: 0, flex: 1, color: colors.textMuted, fontSize: '0.8rem', fontWeight: 700 }}>
            {meta}
          </Box>
        </Stack>
      ) : (
        <Box sx={{ flex: 1 }} />
      )}
      <RouterLink
        to="/register"
        style={{
          color: colors.brand,
          fontWeight: 800,
          fontSize: '0.85rem',
          letterSpacing: '0.03em',
          textDecoration: 'none',
        }}
      >
        Join aero.chat →
      </RouterLink>
    </Box>
  );
}
